import activityApi from '@/api/activity'

const activity = {
  state: {
    qrSign: null
  },
  mutations: {
    UPDATE_QR_ACTIVITY: (state, activityInfo) => {
      state.qrSign = activityInfo
    }
  },
  actions: {
    getQrActivityInfo ({ state, commit }, activityId) {
      return new Promise((resolve, reject) => {
        if (state.qrSign) {
          resolve(state.qrSign)
          return
        }
        activityApi.getQrActivityInfo({ activityId: activityId }).then(response => {
          if (response.data.resultCode === '0') {
            const activityInfo = response.data.resultData.activityDTO
            commit('UPDATE_QR_ACTIVITY', activityInfo)
            resolve(activityInfo)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default activity
